import { createFileRoute, Outlet } from '@tanstack/react-router';

// Layout route for all devices pages, so the list and the device detail routes
// (with their nested tabs) share this segment.
export const Route = createFileRoute('/_app/devices')({
  component: () => <Outlet />,
});
